import {

    NEWLEAVEREQUESTCREATE,
    NEWLEAVEREQUESTCREATE_FAIL,
    NEWLEAVEREQUESTCREATE_SUCCESS,
    GET_NEWLEAVESHAREREQUEST_REQUEST_DETAILS,
    GET_NEWLEAVESHAREREQUEST_REQUEST_DETAILS_SUCCESS,
    GET_NEWLEAVESHAREREQUEST_REQUEST_DETAILS_FAIL,
    UPDATE_NEWLEAVESHAREREQUEST_REQUEST,
    UPDATE_NEWLEAVESHAREREQUEST_REQUEST_SUCCESS,
    UPDATE_NEWLEAVESHAREREQUEST_REQUEST_FAIL,
    DELETE_NEWLEAVESHAREREQUEST_REQUEST,
    DELETE_NEWLEAVESHAREREQUEST_REQUEST_SUCCESS,
    DELETE_NEWLEAVESHAREREQUEST_REQUEST_FAIL,
    Get_Audit_Trail,
    Get_Audit_Trail_Success,
    Get_Audit_Trail_Fail,
    Get_Audit_Trail_History,
    Get_Audit_Trail_Success_History,
    Get_Audit_Trail_Fail_History
} from "./actionTypes";

//Create Actions
export const createNEWLEAVESHAREREQUESTRequest = (payload) => {
    return {
        type: NEWLEAVEREQUESTCREATE,
        payload: payload
    }
};
export const createNEWLEAVESHAREREQUESTRequestSuccess = (response) => {
    return {
        type: NEWLEAVEREQUESTCREATE_SUCCESS,
        payload: response
    }
};
export const createNEWLEAVESHAREREQUESTRequestFail = (error) => {
    return {
        type: NEWLEAVEREQUESTCREATE_FAIL,
        payload: error
    }
};

// //Get Details Actions
export const getNEWLEAVESHAREREQUESTRequestDetails = (payload) => {
    return {
        type: GET_NEWLEAVESHAREREQUEST_REQUEST_DETAILS,
        payload: payload,
    };
};
export const getNEWLEAVESHAREREQUESTRequestDetailsSuccess = (data) => {
    return {
        type: GET_NEWLEAVESHAREREQUEST_REQUEST_DETAILS_SUCCESS,
        payload: data,
    };
};
export const getNEWLEAVESHAREREQUESTRequestDetailsFail = (error) => {
    return {
        type: GET_NEWLEAVESHAREREQUEST_REQUEST_DETAILS_FAIL,
        payload: error,
    };
};

// //Update Actions
export const updateNEWLEAVESHAREREQUESTRequest = (payload) => {

    return {
        type: UPDATE_NEWLEAVESHAREREQUEST_REQUEST,
        payload: payload
    }
};
export const updateNEWLEAVESHAREREQUESTRequestSuccess = (response) => {
    return {
        type: UPDATE_NEWLEAVESHAREREQUEST_REQUEST_SUCCESS,
        payload: response
    }
};
export const updateNEWLEAVESHAREREQUESTRequestFail = (error) => {
    return {
        type: UPDATE_NEWLEAVESHAREREQUEST_REQUEST_FAIL,
        payload: error
    }
};

export const auditTrailRequest = (payload) =>{
    return {
        type:Get_Audit_Trail,
        payload:payload
    }
}
export const auditTrailRequestSuccess = (response) => {
    return {
        type: Get_Audit_Trail_Success,
        payload: response
    }
};
export const auditTrailRequestFail = (error) => {
    return {
        type: Get_Audit_Trail_Fail,
        payload: error
    }
};

export const auditTrailHistoryRequest = (payload) =>{
    return {
        type:Get_Audit_Trail_History,
        payload:payload
    }
}
export const auditTrailHistoryRequestSuccess = (response) => {
    return {
        type: Get_Audit_Trail_Success_History,
        payload: response
    }
};
export const auditTrailHistoryRequestFail = (error) => {
    return {
        type: Get_Audit_Trail_Fail_History,
        payload: error
    }
};

// //Delete Actions
// export const deleteNEWLEAVESHAREREQUESTRequest = (id) => {
//     return {
//         type: DELETE_NEWLEAVESHAREREQUEST_REQUEST,
//         payload: id
//     }
// };
// export const deleteNEWLEAVESHAREREQUESTRequestSuccess = (response) => {
//     return {
//         type: DELETE_NEWLEAVESHAREREQUEST_REQUEST_SUCCESS,
//         payload: response
//     }
// };
// export const deleteNEWLEAVESHAREREQUESTRequestFail = (error) => {
//     return {
//         type: DELETE_NEWLEAVESHAREREQUEST_REQUEST_FAIL,
//         payload: error
//     }
// };


